export default ['JsonRPCService', function (JsonRPCService) {
    return {
        startReinstatement: function startReinstatement(reinstatementDTO) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'startReinstatement', [reinstatementDTO]); // returns reinstatementDTO
        },
        submitReinstatement: function submitReinstatement(reinstatementDTO) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'submitReinstatement', [reinstatementDTO]); // returns reinstatementDTO
        },
        getPendingReinstatement: function getPendingReinstatement(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'getPendingReinstatement', [policyNumber]);
        },
        retrieveReinstatement: function retrieveReinstatement(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'retrieveReinstatement', [jobNumber]); // returns reinstatementDTO
        },
        retrieveReinstatementSummary: function retrieveReinstatementSummary(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'retrieveReinstatementSummary', [jobNumber]); // returns reinstatementDTO
        },
        updateDraftReinstatement: function updateDraftReinstatement(reinstatementDataDTO) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'updateDraftReinstatement', [reinstatementDataDTO]); // returns reinstatementDTO
        },
        quoteReinstatement: function quoteReinstatement(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'quoteReinstatement', [jobNumber]); // returns reinstatementDTO
        },
        bindReinstatement: function bindReinstatement(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'bindReinstatement', [jobNumber]); // returns reinstatementDTO
        },
        withdrawReinstatement: function withdrawReinstatement(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'withdrawReinstatement', [jobNumber]); // returns reinstatementDTO
        },
        isReinstatementQuoted: function isReinstatementQuoted(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/reinstatement', 'isReinstatementQuoted', [jobNumber]); // returns reinstatementDataDTO
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/ReinstatementService.js
// module id = 1793
// module chunks = 0